var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{attrs:{"id":"transferenciaEAproveitamento"}},[_c('Banner'),_c('Ingressar'),_c('Aproveitamento'),_c('Inscreva'),_c('Textolegal'),_c('Inscricao')],1)}
var staticRenderFns = []

export { render, staticRenderFns }